module.exports = __webpack_public_path__ + "images/skoda_smallaf9382e2590705c729ef9050edfb4ecf.png";